import React from 'react';
import { ClassAssembly9A2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly9A2026/>;
  };
  
  export default ClassAssemblyPage;